import React, { useState } from "react";
import breakPoints from "helpers/Styles";
import Image from "next/image";

const ProductFeatures = ({ productTags }) => {
  const [showTitle, setShowTitle] = useState(false);
  const [showTitleCustomization, setShowTitleCustomization] = useState(false);

  const customizationTag = productTags.filter((item) =>
    item.startsWith('customisation:'),
  );

  const customization = customizationTag.length > 0 && customizationTag[0].split(':')[1];

  const featuresTags = productTags.filter((item) =>
    item.startsWith("specifications:")
  );
  const renderPngIcon = (featureType) => {
    if (!featureType) return "icon-default.png";
    if (featureType) {
      let type =
        featureType &&
        featureType.replace(/ /g, "").replace(/-/g, "").toLowerCase();
      if (type == "graphicscard" || type == "graphics-card") return "GPU.png";
      if (type == "cpu" || type == "processor") return "CPU.png";
      if (type == "storage") return "icon-storage.svg";
      if (type == "case") return "CHASSIS.png";
      if (type == "ram") return "RAM.png";
      if (type == "motherboard") return "MOTHERBOARD.png";
      if (type == "cooler" || type == "coolingsystem") return "COOLER.png";
      if (type == "fans") return "icon-cooling.svg";
      if (type == "power") return "POWER SUPPLY.png";
      // if (type == 'operatingsystem') return 'SCREEN.png';
      if (type == "wireless") return "WIFI.png";
      if (type == "cablesleeves") return "CABLE SLEEVE.png";
      if (type == "warranty") return "WARRENTY.png";
      if (type == "display") return "SCREEN.png";
      return `icon-default.png`;
    }
  };

  return (
    <>
      {featuresTags.length > 0 && (
        <div className="product_feature">
          <div>
            {/* <h5 className="title">FEATURES</h5> */}
            <div className="features_section">
              {featuresTags.map((item, index) => {
                let title =
                  typeof item.split(':')[2] !== 'undefined'
                    ? item.split(':')[2].replace(/-/g, ' ')
                    : '';
                const description =
                  typeof item.split(':')[3] !== 'undefined'
                    ? item.split(':')[3].replace(/-/g, ' ')
                    : '';
                return (
                  <div className="feature_item" key={index}>
                    {description && (
                      <div
                        className={'feature_icon ' + title}
                        onMouseLeave={() => setShowTitle(false)}
                        onMouseEnter={() => setShowTitle(index)}
                      >
                        {showTitle === index ? (
                          <span className="feature_item_title" style={{}}>
                            {title}
                          </span>
                        ) : null}
                        <Image draggable={false}
                          src={`/icons/${renderPngIcon(title)}`}
                          alt="product_features"
                          width={25}
                          height={25}
                        />
                      </div>
                    )}
                    <div className="feature_title">{description}</div>
                  </div>
                );
              })}
              {customization && (
                <div className="feature_item">
                  <div
                    className={'feature_icon'}
                    onMouseLeave={() => setShowTitleCustomization(false)}
                    onMouseEnter={() => setShowTitleCustomization(true)}
                  >
                    {showTitleCustomization ? (
                      <span className="feature_item_title">
                        {'Customisation'}
                      </span>
                    ) : null}
                    <Image draggable={false}
                      src={`/icons/icon-default.svg`}
                      alt="product_features"
                      width={25}
                      height={25}
                    />
                  </div>
                  <div className="feature_title">{customization}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .product_feature {
            margin: 0 auto;
            // width: 70%;
            border-bottom: 1px solid #242424;
            margin-top: 30px;
            padding-bottom: 10px;
          }
          .title {
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 20px;
            padding: 0;
          }
          .features_section {
            width: 100%;
          }
          .feature_item {
            width: 100%;
            display: flex;
            gap: 10px;
            align-items: start;
            color: #e4e4e4;
            font-family: 'Roboto-Light';
            font-size: 13px;
            letter-spacing: 0;
            line-height: 20px;
            position: relative;
          }
          .feature_item_title {
            border: 1px solid #3b3b3b;
            padding: 4px;
            position: absolute;
            top: -30px;
            left: -15px;
            text-align: center;
            background: #242424;
          }
          .feature_icon {
            margin-right: 9.7px;
            margin-bottom: -3px;
            cursor: pointer;
          }
          .feature_icon img {
            width: 16.67px;
            height: auto;
        }
          @media (max-width: ${breakPoints.medium}) {
            .product_feature {
              width: 100%;
            }
            .feature_icon {
              margin-top: 3px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ProductFeatures;
